
export function needIndexComponent (chartComponent) {
  return !['text', 'richText', 'borderBlock', 'filterBlock', 'signName'].includes(chartComponent)
}
